import axios from 'axios';

// This client points specifically to the Live Blog Manager routes
const apiClient = axios.create({
  baseURL: '/api/cricket', 
  withCredentials: true,
});

// 1. Get Recent Matches (Default View)
const getRecentMatches = async () => {
    const response = await apiClient.get('/recent-matches');
    return response.data;
};

// 2. Get Featured Tournaments (For the Filter Dropdown)
const getTournaments = async () => {
    const response = await apiClient.get('/tournaments');
    return response.data;
};

// 3. Get Matches for a Specific Tournament (When filtering)
const getMatchesByTournament = async (tslug) => {
    if (!tslug) return { status: "success", data: [] };
    const response = await apiClient.get(`/tournament/${tslug}/matches`);
    return response.data;
};

// 4. Toggle Live Blog Status
const toggleLiveBlog = async (data) => {
    const response = await apiClient.post('/config/toggle-live-blog', data);
    return response.data;
};

// 5. Get Associations (ICC, BCCI, etc.)
const getAssociations = async () => {
    const response = await apiClient.get('/associations');
    return response.data;
};

// 6. Get Tournaments by Association (Drill-down)
const getTournamentsByAssociation = async (key) => {
    if (!key) return { status: "success", data: [] };
    const response = await apiClient.get(`/associations/${key}/tournaments`);
    return response.data;
};

// 7. Batch Toggle (For "Subscribe All")
const toggleLiveBlogBatch = async (payload) => {
    const response = await apiClient.post('/config/toggle-live-blog-batch', payload);
    return response.data;
};

export default {
    getRecentMatches,
    getTournaments,
    getMatchesByTournament,
    toggleLiveBlog,
    getAssociations,
    getTournamentsByAssociation,
    toggleLiveBlogBatch
};